import React from 'react';

import { ItemNumbered } from '../../atoms/item-numbered/item-numbered';

export interface NumberedInstructionsListProps {
  titles: string[];
  descriptions: string[];
  theme?: 'default' | 'light';
}

export const NumberedInstructionsList: React.FC<
  NumberedInstructionsListProps
> = ({ titles, descriptions, theme = 'default' }) => {
  return (
    <>
      {titles.map((title, index) => (
        <ItemNumbered
          key={title}
          theme={theme}
          title={title}
          number={index + 1}
          description={descriptions[index]}
        />
      ))}
    </>
  );
};
